import React,{ useState, useEffect, Fragment } from 'react'
import AllVerification from '../../component/AllVerification';
import { Box } from '@chakra-ui/react';
import { Auth } from '../../component/Auth';
function UnVerified() {
    const [tData, setTData] = useState([]);
    const [isLoading, setIsLoading] = useState({loading: true, error: false})

    useEffect(() => {
      const fetchData = async () => {
        let response = await fetch(`${process.env.REACT_APP_RALCO_API_URL}/api/order?status=ORDER_CANCELED`, {
          method: 'GET',
          headers: {
            'Authorization': Auth()
          }
        });

        try{
          let data = await response.json();
          // data = data.filter((d) => d.verification_status === "Pending")
          setTData(data);
        setIsLoading({loading: false, error: false})

        }catch (error) {
        setIsLoading({loading: false, error: true})
        }

      }
      fetchData()
    }, [])

  return (
    <Fragment>
      <Box p={5} flex="1" w={'100%'}>
    <AllVerification 
      title={'Unverified'}
      head={["Date", "Order ID", "Tenure ID", "Profession", "Customer Status", "Verification Status",""]}
      data={tData}
      isLoading={isLoading} 
      />
     </Box>
    </Fragment>
  )
}

export default UnVerified